import { FunctionComponent } from 'react';
import { CustomModelPage } from 'widgets/customModel/ui/CustomModelPage';

export const CustomModel: FunctionComponent = () => {
	return <CustomModelPage />;
};
